@if (visible()) {
  <div class="nutrix-incoming__backdrop" role="dialog" aria-modal="true" aria-label="Llamada entrante de WhatsApp">
    <div class="nutrix-incoming__card">
      <div class="nutrix-incoming__avatar">
        <i class="pi pi-whatsapp"></i>
      </div>
      <div class="nutrix-incoming__title">Llamada de WhatsApp</div>
      <div class="nutrix-incoming__name">{{ call.incoming()?.name }}</div>
      @if (call.incoming()?.number) {
        <div class="nutrix-incoming__number">+{{ call.incoming()?.number }}</div>
      }

      <div class="nutrix-incoming__actions">
        <p-button
          [rounded]="true"
          size="large"
          severity="danger"
          icon="pi pi-phone"
          label="Rechazar"
          (click)="reject()"
        />
        <p-button
          [rounded]="true"
          size="large"
          severity="success"
          icon="pi pi-phone"
          label="Contestar"
          (click)="answer()"
        />
      </div>
    </div>
  </div>
}
